import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import {
  formatDate,
  formatMoney,
  getShortString,
} from '../../../../../../../../lib/functions/utils';
import { exportBoletinesLabels } from '../../../CompanyReport/components/exportCompany';

export const generatePersonReportPDF = (
  response: any,
  lastUpdate?: Date,
  imgData?: string | null,
) => {
  const doc = new jsPDF();
  const data = response.data;
  const extractDate = formatDate(new Date(), 'large');
  const lastUpdateDate = lastUpdate
    ? formatDate(lastUpdate, 'large')
    : extractDate;

  const renderTable = (
    title: string,
    dataset: any[],
    headers: { key: string; label: string; type?: string }[],
  ) => {
    y += 10;
    doc.setFontSize(12);
    doc.text(title, 14, y);
    y += 2;
    autoTable(doc, {
      startY: y,
      head: [headers.map((h) => h.label)],
      body:
        dataset && dataset.length > 0
          ? dataset.map((row) =>
            headers.map((h) =>
              h.type === 'date'
                ? formatDate(row[h.key])
                : String(row[h.key] ?? ''),
            ),
          )
          : [],
      headStyles: {
        fillColor: [230, 230, 230],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
      },
      styles: { fontSize: 8 },
      margin: { left: 14, right: 14 },
    });
    y = (doc as any).lastAutoTable.finalY;
  };

  let y = 10;
  doc.setFontSize(8);
  doc.text(`Fecha de extracción: ${extractDate}`, 146, y);
  y += 5;
  doc.text(`Fecha de actualización: ${lastUpdateDate}`, 143, y);

  y = 15;

  // Título
  doc.setFontSize(14);
  doc.text('Informe Buro Persona', 14, y);
  y += 10;

  doc.text('Antecedentes Personales y Financieros', 14, y);
  doc.setDrawColor('#0F23DF');
  doc.setLineWidth(0.4);
  doc.line(14, y + 1, 190, y + 1);
  y += 10;

  // Datos personales
  doc.setFontSize(10);
  doc.text(
    `Nombre: ${getShortString(data.identificationDetails.name, 34)}`,
    14,
    y,
  );
  doc.text(`Edad: ${data.identificationDetails.age}`, 120, y);
  y += 6;
  doc.text(`Género: ${data.identificationDetails.Gender}`, 14, y);
  doc.text(
    `Fecha de Nacimiento: ${formatDate(data.identificationDetails.birthDate)}`,
    120,
    y,
  );
  y += 6;
  doc.text(`Email: ${data.identificationDetails.emails}`, 14, y);
  doc.text(
    `Profesión: ${data.identificationDetails.profession || 'N/A'}`,
    120,
    y,
  );
  y += 6;
  doc.text(`Nacionalidad: ${data.identificationDetails.nationality}`, 14, y);
  doc.text(`Estado Civil: ${data.identificationDetails.maritalStatus}`, 120, y);
  y += 10;

  // Económico
  doc.setFontSize(12);
  doc.text('Situación Económica', 14, y);
  y += 6;
  doc.setFontSize(10);
  doc.text(`Ingreso: ${formatMoney(data.identificationDetails.salary)}`, 14, y);
  doc.text(`Fonasa: ${data.other?.IsFonasa === '1' ? 'Sí' : 'No'}`, 120, y);
  y += 6;
  doc.text(`GSE: ${data.patrimony?.gse}`, 14, y);
  doc.text(`Cod. ISE: ${data.identificationDetails.other?.CodIse}`, 120, y);
  y += 6;
  doc.text(
    `Fecha Actualización ISE: ${formatDate(data.identificationDetails.other?.DateUpdateIse)}`,
    14,
    y,
  );
  doc.text(`Observaciones SII: ${data.tributary?.observations ?? 0}`, 120, y);
  y += 6;
  doc.text(
    `Boletín Concursal: ${data.patrimony?.boletinConcursal === '1' ? 'Sí' : 'No'}`,
    14,
    y,
  );
  y += 10;

  // Bienes
  doc.setFontSize(12);
  doc.text('Garantías', 14, y);
  doc.setFontSize(10);
  y += 6;
  doc.text(`Score actual: ${data.patrimony.riskScore.score}`, 14, y);
  y += 6;
  doc.text(`Propiedades: ${data.patrimony.realStateNumber}`, 14, y);
  doc.text(
    `Valor Propiedades: ${formatMoney(data.patrimony.realStateValuation)}`,
    120,
    y,
  );
  y += 6;
  doc.text(`Vehículos: ${data.patrimony.vehiclesNumber}`, 14, y);
  doc.text(
    `Valor Vehículos: ${formatMoney(data.patrimony.vehiclesValuation)}`,
    120,
    y,
  );
  y += 6;
  doc.text(
    `Cuentas Bancarias: ${data.patrimony.bankAccounts?.length || 0}`,
    14,
    y,
  );
  doc.text(`Sociedades: ${data.patrimony.societies?.length || 0}`, 120, y);

  if (imgData) {
    y += 10;
    doc.setFontSize(12);
    doc.text('Score Histórico', 14, y);
    doc.setFontSize(10);
    y += 6;
    doc.addImage(imgData, 'PNG', 10, y, 180, 45);
    y += 45;
  }

  // Tablas
  renderTable('Direcciones', data.identificationDetails.addresses, [
    { key: 'StreetAndNumber', label: 'Dirección' },
    { key: 'AditionalInfo', label: 'Info Adicional' },
    { key: 'Communes', label: 'Comuna' },
    { key: 'Region', label: 'Región' },
    { key: 'AddressDate', label: 'Fecha registro', type: 'date' },
  ]);

  renderTable('Números de Teléfono', data.identificationDetails.phones, [
    { key: 'Telephone', label: 'Número' },
    { key: 'SourceOfTelephone', label: 'Fuente' },
    { key: 'TelephoneDate', label: 'Fecha registro', type: 'date' },
  ]);

  renderTable('Sociedades', data.identificationDetails.societies, [
    { key: 'SocietiyRUT', label: 'Rut' },
    { key: 'descSociety', label: 'Descripción' },
  ]);

  renderTable(
    'Actividades',
    [
      {
        economicCode: data.tributary.economicCode,
        economicActivity: data.tributary.economicActivity,
      },
    ],
    [
      { key: 'economicCode', label: 'Código' },
      { key: 'economicActivity', label: 'Actividad Económica' },
    ],
  );

  // Sociedades (fix)
  renderTable('Sociedades', data.patrimony.societies, [
    { key: 'SocietiyRUT', label: 'Rut' },
    { key: 'descSociety', label: 'Descripción' },
  ]);

  renderTable('Bancos', data.patrimony.bankAccounts, [
    { key: 'bank_name', label: 'Banco' },
  ]);

  y += 10;

  doc.setFontSize(14);
  doc.text('Antecedentes Burós', 14, y);
  doc.setDrawColor('#0F23DF');
  doc.setLineWidth(0.4);
  doc.line(14, y + 1, 190, y + 1);
  y += 10;

  doc.setFontSize(12);
  doc.text('Resumen de Burós', 14, y);
  y += 6;
  doc.setFontSize(10);
  doc.text(
    `Últimos 6 meses: ${formatMoney(data.debts.summary.docsAmountLast6)}`,
    14,
    y,
  );
  doc.text(
    `Últimos 12 meses: ${formatMoney(data.debts.summary.docsAmountLast12)}`,
    120,
    y,
  );
  y += 6;
  doc.text(
    `Últimos 24 meses: ${formatMoney(data.debts.summary.docsAmountLast24)}`,
    14,
    y,
  );
  doc.text(
    `Más de 24 meses: ${formatMoney(data.debts.summary.docsAmountMoreThan24)}`,
    120,
    y,
  );
  y += 6;

  // Boletines
  const boletines = ['boled', 'bolcom', 'bolab', 'icom'];
  boletines.forEach((key) => {
    const boletin = data.debts[key];
    const config = exportBoletinesLabels[key];
    renderTable(config.label, boletin.documents, config.dataHeaders);
  });

  renderTable('Consultas Recientes', data.consults.historicalRate, [
    { key: 'date', label: 'Fecha', type: 'date' },
    { key: 'businessName', label: 'Empresa' },
    { key: 'report', label: 'Tipo de Reporte' },
  ]);

  // Guardar
  doc.save(`InformePersona-${data.identificationDetails.name}.pdf`);
};
